import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { UtilService } from '@shared/services/util.service';
import { AuthService } from '@core/services/auth.service';
import { Subject, takeUntil } from 'rxjs';
import { decrypt } from '@core/utils/EncryptUtil';
import { DeviceService } from '@core/services/device.service';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    RouterModule,
  ],
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css'],
})
export class ToolbarComponent implements OnInit, OnDestroy {
  isLogged = false;
  stdBtn = true;
  idTienda: string = '';
  idRolUsuario: number = 0; // Propiedad para almacenar el rol del usuario
  nombreUsuario: string = "";
  rolUsuario: string = ""; // Propiedad para almacenar el rol del usuario
  @Output() toggleSidenav = new EventEmitter();
  private destroy$ = new Subject<void>();

  isMobile = false;
  isSidenavOpen = true;
  fotoPerfil = "";

  constructor(
    private router: Router,
    private utilSvc: UtilService,
    private authSvc: AuthService,
    private deviceService: DeviceService,
  ) {}

  ngOnInit(): void {
    this.deviceService.isMobile$.pipe(takeUntil(this.destroy$)).subscribe((isMob) => {
      this.isMobile = isMob;
      this.isSidenavOpen = !isMob; // ⬅️ Sidenav cerrado en mobile, abierto en desktop
      if(!isMob)
      this.toggleSidenav.emit(); // ⬅️ Emitir el estado inicial correcto
    });

    this.authSvc.isLogged$.pipe(takeUntil(this.destroy$)).subscribe((logueado) => {
      this.isLogged = logueado;
    });

    this.utilSvc.btnSidenav$.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
      this.stdBtn = resp;
    });

    this.authSvc.isUserName$.pipe(takeUntil(this.destroy$)).subscribe((nombre) => {
      this.nombreUsuario = nombre || '';
    });

    this.obtenerRolUsuario();
  }


  onToggleSidenav(): void {
    this.toggleSidenav.emit();
  }

  irTiendas(): void {
    this.router.navigate(['/admin/home']);
  }

  verDatosSocio(): void {
    this.router.navigate(['/admin/datos-socio']);
  }

  abrirConfiguraciones(): void {
    this.router.navigate(['/admin/ajustes']);
  }

  abrirParametros(): void{
    this.router.navigate(['/admin/parametros']);
  }
  
  private obtenerRolUsuario(): void {
    const encryptedUsuario = localStorage.getItem('tiendaGarantia');
    if (encryptedUsuario) {
      try {
        const usuario = decrypt<{ internalId: number, rol: string }>(encryptedUsuario);
        this.idRolUsuario = usuario!.internalId || 0; // Asignar el rol si existe
        this.rolUsuario = usuario!.rol;
      } catch (error) {
        console.error('Error al desencriptar el usuario:', error);
      }
    } else {
      console.warn('No se encontró información del usuario en localStorage.');
    }
  }

  onLogout(): void {
    this.utilSvc.openSidenav({ valueBtn: false, valueSide: false });
    this.authSvc.logout();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  navigateTo(route: string): void {
    this.router.navigate([route]);
  }

}
